export default {
  // Two: 2,
  Ten: 10,
  Twen: 20,
  Thir: 30,
  Fif: 50,
  Hunder: 100
};
